import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import commandListener from './command/command.listener';
import adobeAnalyticListener from './adobeAnalytic/adobeAnalytic.listener';

/**
 * All listeners are imported and merged to a flat array of listeners. These are all initialized when the store is created.
 */
export default [].concat(_toConsumableArray(adobeAnalyticListener), _toConsumableArray(commandListener));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/redux/listeners.js
// module id = 4683
// module chunks = 11